import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const OpportunityRatingListDetails = () => {
  const columns = [
    { label: 'Name', value: 'name' },
    { label: 'Value', value: 'value' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];
  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/opportunity/rating/details/' + encodedId;
  };
  return <ListTemplate fetchUrl={API_DOMAIN + API_ROUTES['opportunityRating']} columns={columns} onAccessDetails={handleAccessDetails} />;
};

export default OpportunityRatingListDetails;